
<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item label="" prop="projectName">
        <el-input v-model="searchInfo.projectName" size='small' placeholder="输入项目名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="" prop="projectProvince">
        <el-cascader
          v-model="searchInfo.addr"
          :options="addrList"
          :props="{value: 'label', children: 'children', label: 'label'}"
          clearable
          placeholder="请选择项目区域"
          filterable
          ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchInfo.projectType" placeholder="请选择项目类型" filterable clearable>
          <el-option
            v-for="item in projectTypeList"
            :key="item.dicCode"
            :label="item.dicValue"
            :value="item.dicCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchInfo.projectState" placeholder="请选择项目状态" filterable clearable>
          <el-option label="未开工" value="1">
          </el-option>
          <el-option label="在建" value="2">
          </el-option>
          <el-option label="已移交" value="3">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch" class="medium">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" size='small' @click='addProject' type="primary" icon='el-icon-plus' v-show="$ButtonShow('YHP_ADD_01')">新增项目</el-button>
    <el-table
      class="global-table"
      stripe
      :data="tableData"
      v-loading="loading">
      <template v-for="(item, index) in itemList">
        <el-table-column v-if="item.prop === 'addr'" :label="item.label" minWidth="150px" show-overflow-tooltip :key="index">
          <template v-slot="{ row }">
            <span>{{row.projectProvince || ''}}{{row.projectCity || ''}}{{row.projectArea || ''}}{{row.projectAddr || ''}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.prop === 'projectState'" :label="item.label" show-overflow-tooltip :key="index">
          <template v-slot="{ row }">
            <span>{{getState(row.projectState)}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else :label="item.label" :prop="item.prop" show-overflow-tooltip :key="index"></el-table-column>
      </template>
      <el-table-column label="操作" width="100px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="$router.push(`/projectList/detail/base?projectId=${row.projectId}`)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination
      :total="total"
      :current-page.sync="page"
      :page-size.sync="size"
      @current-change="getList"
      @size-change="getList"></GlobalPagination>
  </el-card>
</template>
<script>
export default {
  name: 'List',
  components: {
  },
  data () {
    return {
      addrList: [],
      searchInfo: {
        projectName: '',
        addr: [],
        projectType: '',
        projectState: ''
      },
      itemList: [
        {
          label: '项目名称',
          prop: 'projectName'
        },
        {
          label: '项目地址',
          prop: 'addr'
        },
        {
          label: '养护开始时间',
          prop: 'maintStartTime'
        },
        {
          label: '养护结束时间',
          prop: 'maintEndTime'
        },
        {
          label: '项目面积',
          prop: 'maintAcreage'
        },
        {
          label: '养护单位',
          prop: 'maintUnit'
        },
        {
          label: '项目类型',
          prop: 'projectTypeName'
        },
        {
          label: '项目状态',
          prop: 'projectState'
        }
      ],
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      projectTypeList: []
    }
  },
  computed: {
  },
  created () {
    this.getAddrList()
    this.getList()
    this.getProjectTypeList()
  },
  methods: {
    // 搜索
    onSearch () {
      this.page = 1
      this.getList()
    },
    // 获取区域列表
    getAddrList () {
      this.$axios.get(this.$apis.common.getRegion).then(res => {
        this.addrList = res || []
      })
    },
    // 项目类型
    getProjectTypeList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'projectType' }).then(res => {
        this.projectTypeList = res.projectType || []
      })
    },
    // 获取列表数据
    getList () {
      this.loading = true
      const info = {
        projectName: this.searchInfo.projectName,
        projectProvince: this.searchInfo.addr[0] || '',
        projectCity: this.searchInfo.addr[1] || '',
        projectArea: this.searchInfo.addr[2] || '',
        projectType: this.searchInfo.projectType,
        projectState: this.searchInfo.projectState
      }
      this.$axios.get(this.$apis.project.selectYhProjectByPage,
        {
          ...info,
          page: this.page,
          size: this.size
        }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    getState (state) {
      const arr = ['', '未开工', '在建', '已移交']
      return arr[Number(state)]
    },
    // 新增项目
    addProject () {
      this.$router.push({ name: 'projectAdd' })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
